export default __webpack_public_path__ + "static/media/logo138x75white.b57d2e88.png";